import React from "react";
import "../css/AC_Annual_Maintenance.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";


export default function AC_Annual_Maintenance() {
  return (
    <>
     <Topbar/>
          <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Keep Your Cool</p>

          <h1 className="ac-hero-title">
           Comprehensive AC Annual
            <br />
          Maintenance Services
          </h1>

          <p className="ac-hero-subtitle">
           Get all kinds of AC Annual maintenance service at lowest price. Contact us to get a free quote!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Partner for AC Annual Maintenance Service</h2>

            <p> At<a className="ac-link" href="#">Jay Ambe AC Service</a> we pride ourselves on being your go-to solution for all types of <strong>air conditioning annual maintenance services. </strong> With years of expertise in the HVAC industry, our dedicated team is committed to ensuring that your cooling systems operate at peak performance throughout the year. </p>

            <p>
            Regular maintenance is crucial for prolonging the lifespan of your air conditioning units and enhancing their efficiency. Our comprehensive annual maintenance service includes thorough inspections, cleaning, and necessary repairs to keep your AC running smoothly. We understand that a well-maintained air conditioner not only provides optimal comfort but also reduces energy costs significantly.</p>

            <p>
            Our skilled technicians are trained to handle various brands and models of air conditioning systems. They utilize advanced tools and techniques to diagnose potential issues before they become major problems, saving you time and money in the long run. During our maintenance visits, we check refrigerant levels, clean coils, inspect electrical components, replace filters, and ensure proper airflow – every detail matters when it comes to maintaining an efficient system.       </p>

            <p>
      At Krishna AC Service, customer satisfaction is our top priority. We tailor our services according to your specific needs and provide flexible scheduling options to accommodate your busy lifestyle. Our transparent pricing ensures that there are no hidden fees or surprises when it comes time for payment.
            </p>

            <p>
          Don’t wait until a small issue turns into a costly repair! Trust Krishna AC Service for reliable annual maintenance that keeps you cool during those hot summer months. Experience peace of mind knowing that experts are taking care of your cooling needs with professionalism and dedication
            </p>

            <p>
              Contact us today to learn more about our comprehensive AC annual maintenance services and schedule an appointment with one of our experienced technicians!
            </p>

          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/AC-Annual-Maintenance.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
    <Herolast  />
      <Footer  />
     
    </>
  );
}
